export default __webpack_public_path__ + "static/section_10_details_1-e72ed1ffb31559256769f1c36b0c301a.png";